import * as React from 'react';
import { SGBase, SGBaseProps } from './sgbase';
import bind from 'bind-decorator';
import { SgNode, CreateSgNode, FullyQualifyIDIfNeeded, BuildSgNodeReturn, TraversalState } from './sgproto';
import { Mountable } from './mountable';

interface DashboardTabProps extends SGBaseProps
{
	tabName?: string;
	iconUri?: string;
	iconOverlayKey?: string;
	summonOverlayKey: string;
	mountableUnqualifiedID?: string;
}

export class DashboardTab extends SGBase<DashboardTabProps, null>
{
	private m_sMountableUnqualifiedID: string;

	constructor( props: DashboardTabProps )
	{
		super( props );
		if ( this.props.iconUri !== undefined && this.props.iconOverlayKey !== undefined )
		{
			throw new Error( "DashboardTab cannot have both an explicit iconUri and iconOverlayKey set in props." );
		}
		super.setBuildNodeOverride( this.buildNode );
		this.m_sMountableUnqualifiedID = props.mountableUnqualifiedID ?? ( "" + this.getSGID() + "_mountable" );
	}

	public getNodeType(): string
	{
		return "dashboardtab";
	}

	@bind private buildNode( traversalState: TraversalState, domNode: HTMLElement ): BuildSgNodeReturn
	{
		const node = this.createSgNode( domNode );
		node.properties.tab_name = this.props.tabName ?? "";
		node.properties.mountable_id = FullyQualifyIDIfNeeded( this.m_sMountableUnqualifiedID );
		node.properties.icon_uri = this.props.iconUri;
		node.properties.icon_overlay_key = this.props.iconOverlayKey;
		node.properties.summon_overlay_key = this.props.summonOverlayKey;
		return [traversalState, node];
	}

	public internalRender()
	{
		return (
			<vsg-node id={ this.props.id } >
				<Mountable id={ this.m_sMountableUnqualifiedID } >
					{ this.props.children }
				</Mountable>
			</vsg-node> );
	}
}
